// 市场枚举
export var RegionTypeEnum;
(function (RegionTypeEnum) {
    RegionTypeEnum[RegionTypeEnum["HK"] = 0] = "HK";
    RegionTypeEnum[RegionTypeEnum["US"] = 1] = "US";
})(RegionTypeEnum || (RegionTypeEnum = {}));
// 涨跌色枚举
export var QuotationColor;
(function (QuotationColor) {
    QuotationColor[QuotationColor["RED_UP_GREEN_DOWN"] = 0] = "RED_UP_GREEN_DOWN";
    QuotationColor[QuotationColor["GREEN_UP_RED_DOWN"] = 1] = "GREEN_UP_RED_DOWN";
})(QuotationColor || (QuotationColor = {}));
